import PropTypes from 'prop-types';
import logo from '../assets/images/logo-mark.png';
import Icon from './Icon';

/**
 * Signed in, and no box any more.
 *
 * Reached only when there were devices a moment ago and there are none now,
 * which in practice means a shared box was unshared. The other way to hold no
 * devices -- having just unboxed your first one -- goes to the claim screen as
 * it always did.
 *
 * The two need separating because the claim screen asks for an eight-character
 * code. Someone who was given access by a family member has never seen one and
 * never will, so that screen reads to them as an app that has broken and locked
 * them out. This says what happened in a sentence, and offers both ways forward
 * rather than leaving Sign out as the only button that works.
 *
 * Deliberately not accusatory and deliberately not alarming: the usual reason a
 * box stops being shared is that a household rearranged itself, not that
 * anything went wrong.
 */
const NoAccess = ({ User, onAddDevice, onSignOut }) => (
  <div className="auth">
    <img src={logo} alt="" className="auth__logo" />
    <h1 className="auth__title">No box to show</h1>
    <p className="auth__sub">
      The Prayer Box you had access to is no longer shared with this account.
    </p>

    <div className="notice notice--info">
      If that is unexpected, ask whoever shared it with you &mdash; only the
      owner of a box can change who uses it. Nothing has happened to the box
      itself, and it is still running wherever it is.
    </div>

    <button className="btn btn--primary btn--block" onClick={onAddDevice}>
      <Icon name="plus" size={16} /> Set up a Prayer Box of my own
    </button>

    <p className="auth__foot">
      Signed in as {User?.email || User?.name || 'this account'}.{' '}
      <button onClick={onSignOut}>Sign out</button>
    </p>
  </div>
);

NoAccess.propTypes = {
  User:        PropTypes.object,
  onAddDevice: PropTypes.func.isRequired,
  onSignOut:   PropTypes.func.isRequired,
};

export default NoAccess;
